import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { setClassNames } from 'ddc-classnames-js';
import { useLabels } from 'wsm-common-data';
import PropTypes from 'prop-types';
import { g } from '../../global-constants';
import useFocusTrap from '../../hooks/modern/useFocusTrap';

const FlyOut = ({
	isOpen,
	onClose,
	dropDownRef = React.createRef(),
	inputElementRef = React.createRef(),
	openButtonRef,
	closeModal
}) => {
	const labels = useLabels();
	const [localIsOpen, setLocalIsOpen] = useState(false);
	const classNames = [
		'modern-search-flyout',
		'box',
		'p-4',
		localIsOpen && 'slide-left'
	];

	const closeClassNames = [
		'btn-unstyled text-link-muted',
		'py-3',
		'px-4',
		'border-neutral-0-alpha-3',
		'float-right'
	];

	useFocusTrap(
		[openButtonRef, dropDownRef],
		inputElementRef,
		isOpen,
		closeModal
	);
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			setLocalIsOpen(true);
		}, 50);

		return () => {
			clearTimeout(timeoutId);
		};
	}, [isOpen]);

	const flyOutContent = (
		<>
			{/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
			<div
				className="modern-search-modal clearfix"
				onClick={() => onClose(g.CLOSE_BUTTON)}
				onKeyDown={() => onClose(g.CLOSE_BUTTON)}
				role="dialog"
				data-testid="modern-flyout-background"
			/>
			<div
				className={setClassNames(classNames)}
				aria-labelledby="search-modal-headline"
				ref={dropDownRef}
				tabIndex="-1"
				data-testid="modern-flyout"
			>
				<div className="p-3 clearfix">
					<h3
						className="d-inline float-left my-3 text-capitalize"
						id="search-modal-headline"
					>
						{labels.get('SEARCH')}
					</h3>
					<button
						type="button"
						tabIndex="0"
						aria-label={labels.get('CLOSE_MODAL')}
						className={setClassNames(closeClassNames)}
						onClick={() => onClose(g.CLOSE_BUTTON)}
						data-testid="close-button"
					>
						<i
							className="ddc-icon ddc-icon-remove2 icon-size-2"
							aria-hidden="true"
						/>
					</button>
				</div>
				<div className="p-3">I am example content.</div>
			</div>
		</>
	);

	return createPortal(flyOutContent, document.body);
};

FlyOut.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
	dropDownRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.shape() })
	]),
	inputElementRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.shape() })
	]),
	closeModal: PropTypes.func
};

export default FlyOut;
